module.exports = __webpack_public_path__ + "static/media/blur_how_to_cook_pc.34524fe9.png";